const state = {
    generalInfo: Object,
    generalInfoErrors: {
        initial_assessment_date: null,
        followup_assessment_date: null,
        number_staff_receiving_technical_assistance: null,
        youngest_age_years: null,
        youngest_age_months: null,
        oldest_age_years: null,
        oldest_age_months: null,
        number_children_initial: null,
        number_children_followup: null,
        number_allergies: null,
        number_asthma: null,
        number_diabetes: null, 
        number_developmental_delays: null, 
        number_seizures: null,
        number_social_emotional_needs: null,
        number_children_special_health_care_needs: null,
        number_children_medication_needs: null
    },
    facilityLicense: String
}

const getters = {
    //
}

const mutations = {
    setGeneralInfo (state, data) {
        return state.generalInfo = data
    },
    setGeneralInfoErrors (state, data) {
        return state.generalInfoErrors = { ...state.generalInfoErrors, [data.field]: data.message }
    },
    resetGeneralInfoErrors (state, data) {
        return state.generalInfoErrors = data
    },
    setGeneralInfoElement (state, data) {
        return state.generalInfo = { ...state.generalInfo, [data.id]: data.value }
    },
    setFacilityLicense (state, data) {
        return state.facilityLicense = data
    }
}

const actions = {
    setGeneralInfoElement (context, data) {
        context.commit("setGeneralInfoElement", data)
    },
    fetchGeneralInfo (context, data) {
        axios.get('/api/general-info', {params: data})
        .then( (response) => {
            context.commit("setGeneralInfo", response.data)
        })
        .catch( (e) => {
            console.log("Error: general_info.js, fetchGeneralInfo(), "+ e.message)          
        })
    },
    saveGeneralInfo (context, data) {
        axios.post('/api/general-info', data)
        .then( (response) => {
            context.commit("setGeneralInfo", response.data)
            resetErrors(context)        
        })
        .catch( (e) => {
            console.log("Error: general_info.js, saveGeneralInfo(), "+ e.message)
            processErrors(context, e.response.data)
        })
    },
    lockGeneralInfo (context, data) {
        context.commit("setGeneralInfoElement", data[0])

        axios.post('/api/general-info-lock', state.generalInfo)
        .then( (response) => {
            context.commit("setGeneralInfo", response.data)      
        })
        .catch( (e) => {
            console.log("Error: general_info.js, lockGeneralInfo(), "+ e.message)
            processErrors(context, e.response.data)
        })
    },
    unlockGeneralInfo (context, data) {
        context.commit("setGeneralInfoElement", data[0])

        axios.post('/api/general-info-unlock', state.generalInfo)
        .then( (response) => {
            context.commit("setGeneralInfo", response.data)    
        })
        .catch( (e) => {
            console.log("Error: general_info.js, unlockGeneralInfo(), "+ e.message)
            processErrors(context, e.response.data)
        })
    },
    fetchFacilityLicense (context, data) {
        axios.get('/api/facility-license', {params: data})
        .then( (response) => {
            context.commit("setFacilityLicense", response.data)
        })
        .catch( (e) => {
            console.log("Error: general_info.js, fetchFacilityLicense(), "+ e.message)          
        })
    },
}

function processErrors (context, response) {
    for (const [key, value] of Object.entries(response.errors)) {
        context.commit("setGeneralInfoErrors", {field: key, message: value[0]})
    }   
}

function resetErrors (context) {
    var generalInfoErrors = {
        initial_assessment_date: null,
        followup_assessment_date: null,
        number_staff_receiving_technical_assistance: null,
        youngest_age_years: null,
        youngest_age_months: null,
        oldest_age_years: null,
        oldest_age_months: null,
        number_children_initial: null,
        number_children_followup: null,
        number_allergies: null,
        number_asthma: null,
        number_diabetes: null, 
        number_developmental_delays: null, 
        number_seizures: null,
        number_social_emotional_needs: null,
        number_children_special_health_care_needs: null,
        number_children_medication_needs: null
    }

    context.commit("resetGeneralInfoErrors", generalInfoErrors)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}